import { toast } from "sonner";
import { TE } from "../i18n/te";
import { gaEvent } from "./analytics";

export const WATTZAP_OS_BASE_URL = process.env.REACT_APP_WATTZAP_OS_URL;
export const WATTZAP_OS_START_URL = `${WATTZAP_OS_BASE_URL}/start/`;
export const OS_REDIRECT_NOTICE =
  "Opening the secure WattZap EnergyScan portal. The preview service may take up to one minute to start.";
export const OS_FALLBACK_TEXT = "If the secure portal did not open, click here.";

const tr = (s) => {
  try { return localStorage.getItem("wz_lang") === "te" ? TE[s] || s : s; } catch { return s; }
};

export const buildWattzapOSUrl = (params = {}) => {
  const clean = Object.fromEntries(
    Object.entries({ src: "website", ...params }).filter(([, v]) => typeof v === "string" && v)
  );
  return `${WATTZAP_OS_START_URL}?${new URLSearchParams(clean).toString()}`;
};

export const isEmbeddedPreview = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const goToWattzapOS = (params = {}) => {
  const url = buildWattzapOSUrl(params);
  if (isEmbeddedPreview()) {
    window.open(url, "_blank", "noopener,noreferrer");
  } else {
    window.location.assign(url);
  }
};

export const openEnergyScanPortal = (params = {}) => {
  const url = buildWattzapOSUrl(params);
  gaEvent("energyscan_cta_click", { mode: isEmbeddedPreview() ? "new_tab" : "same_tab" });
  if (isEmbeddedPreview()) {
    window.open(url, "_blank", "noopener,noreferrer");
    toast.info(tr(OS_REDIRECT_NOTICE), {
      duration: 10000,
      description: (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="os-fallback-link"
          className="underline underline-offset-2 font-medium"
        >
          {tr(OS_FALLBACK_TEXT)}
        </a>
      ),
    });
  } else {
    toast.info(tr(OS_REDIRECT_NOTICE), { duration: 1800 });
    setTimeout(() => {
      window.location.assign(url);
    }, 1500);
  }
};
